/**
 * Default values are coming from the requirements
 *
 * @see https://jira.migros.net/browse/IHGWEBCC-1639
 */

export const BEDROOMS_MIN = 0
export const BEDROOMS_MAX = 19
export const BATHROOMS_MIN = 0
export const BATHROOMS_MAX = 19

export const PAX_MIN = 1
export const PAX_MAX = 47
export const PETS_MIN = 0
export const PETS_MAX = 3
export const PETS_MIN_ALLOWED = 1
